
import ArrowIcon from '../icons/ArrowIcon.vue';
import SearchIcon from '../icons/SearchIcon.vue';
import { ACADEMY_GUIDE_CATEGORIES } from '~/utils/constants/academyConstants';
import OverflowContainer from './OverflowContainer.vue';
import { mapActions, mapGetters } from 'vuex';
import GuideSearchResultCard from './GuideSearchResultCard.vue';
import GuideSearchResultCardSkeleton from '../atom/skeleton/GuideSearchResultCardSkeleton.vue';
import { ImageFormat } from '~/utils/behavior/imageUrl';

export default {
  name: 'AcademyGuidesSearchModal',
  components: {
    ArrowIcon,
    SearchIcon,
    OverflowContainer,
    GuideSearchResultCard,
    GuideSearchResultCardSkeleton,
  },
  data() {
    return {
      query: '',
      selectedCategory: 'all',
      imageFormats: ImageFormat,
    };
  },
  computed: {
    categories() {
      return ACADEMY_GUIDE_CATEGORIES.map((category) => ({
        ...category,
        label: this.$t(category.label_translation_key),
      }));
    },
    filteredGuides() {
      let guides = this.guides;
      if (this.selectedCategory !== 'all') {
        guides = guides.filter(
          (g) =>
            g.category.toLowerCase() === this.selectedCategory.toLowerCase()
        );
      }
      if (this.query.trim()) {
        const query = this.query.toLowerCase();
        guides = guides.filter((g) => {
          return (
            g.title.toLowerCase().includes(query) ||
            g.description.toLowerCase().includes(query)
          );
        });
      }
      return guides;
    },
    ...mapGetters('academy', ['guides', 'guidesLoading']),
  },
  async mounted() {
    document.body.style.overflow = 'hidden';
    await this.getGuides({ language: this.$i18n.locale });
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions('academy', ['getGuides']),
    handleCategoryChange(categoryKey) {
      this.selectedCategory = categoryKey;
    },
    handleCardClick(guide) {
      this.$emit('guideSelected', guide);
    },
  },
};
